import { TwoFactorTokenResponse } from "@accurx/api/account";
import { useLoginMethod } from "@accurx/auth";
import {
    IWrappedResult,
    getApiEndpoint,
    httpClient,
    returnDataOrThrow,
} from "@accurx/shared";
import { useQuery } from "@tanstack/react-query";

const GENERATE_TWO_FACTOR_TOKEN = "GenerateTwoFactorToken";

type TwoFactorTokenParams = {
    email: string;
    usingUserId: "true" | "false";
    loginMethod: string;
    loginCorrelationId?: string;
};

const generateTwoFactorToken = async (
    tokenParams: TwoFactorTokenParams,
): Promise<IWrappedResult<TwoFactorTokenResponse>> => {
    const urlParams = new URLSearchParams(tokenParams);

    return httpClient.getReturnJsonSafeAsync(
        getApiEndpoint({
            path: `/api/account/generateTwoFactorToken?${urlParams.toString()}`,
        }),
    );
};

export const useGenerateTwoFactorToken = ({
    email,
    usingUserId,
    loginCorrelationId,
}: Omit<TwoFactorTokenParams, "loginMethod">) => {
    const loginMethod = useLoginMethod();

    return useQuery<TwoFactorTokenResponse, Error, TwoFactorTokenResponse>({
        queryKey: [GENERATE_TWO_FACTOR_TOKEN, email],
        queryFn: async () => {
            const tokenParams = {
                email,
                usingUserId,
                loginMethod: loginMethod.toString(),
                ...(loginCorrelationId && { loginCorrelationId }),
            };

            const response = await generateTwoFactorToken(tokenParams);

            return returnDataOrThrow(response);
        },
    });
};
